module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "new_list"
  }, _vm._l((_vm.news), function(row, index) {
    return _c('div', {
      staticClass: "news_box"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "day"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(row.c_date)))]), _vm._v(" "), _c('span', {
      staticClass: "month"
    }, [_vm._v(_vm._s(_vm._f("formatMonth")(row.c_date)) + "月")])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.c_title))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("truncate")(row.c_content, 200)) + "\n                                    "), _c('router-link', {
      staticClass: "pull-right more",
      attrs: {
        "to": '/news/' + index
      }
    }, [_vm._v("\n                                    了解更多"), _c('span', {
      staticClass: "glyphicon glyphicon-menu-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  })), _vm._v(" "), _vm._m(3, false, false)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("最新消息")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("主要消息")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("活動消息")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])]), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-641775da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 296
// module chunks = 1